/* global $ */

var WORKER_URL = 'https://inquiry-bot.notret.workers.dev';

export function initInquiry() {
  var $modal = $('#inquiry-modal');
  var $form = $('#inquiry-form');
  var $status = $('#inquiry-status');
  var $stoneName = $('#inquiry-stone-name');
  var $stoneInput = $('#inquiry-stone');

  // Open modal
  $(document).on('click', '[data-stone]', function (e) {
    e.preventDefault();
    var name = $(this).data('stone');
    $stoneName.text(name);
    $stoneInput.val(name);
    $status.text('').removeClass('inquiry-form__status--error inquiry-form__status--ok');
    $form[0].reset();
    $stoneInput.val(name);
    $modal.removeAttr('hidden');
    $('body').css('overflow', 'hidden');
    $('#inquiry-name').focus();
  });

  // Close modal
  $modal.on('click', '.modal-dialog__close', closeModal);
  $modal.on('click', function (e) {
    if (e.target === this) closeModal();
  });
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && !$modal.attr('hidden')) closeModal();
  });

  function closeModal() {
    $modal.attr('hidden', '');
    $('body').css('overflow', '');
  }

  // Phone mask: +7 (___) ___-__-__
  $(document).on('input', 'input[type="tel"]', function () {
    var val = $(this).val().replace(/\D/g, '');
    if (val.length === 0) { $(this).val(''); return; }
    if (val[0] === '8' || val[0] === '7') val = val.substring(1);
    var result = '+7';
    if (val.length > 0) result += ' (' + val.substring(0, 3);
    if (val.length >= 3) result += ') ' + val.substring(3, 6);
    if (val.length >= 6) result += '-' + val.substring(6, 8);
    if (val.length >= 8) result += '-' + val.substring(8, 10);
    $(this).val(result);
  });

  // Submit handler for both modal and inline forms
  function handleSubmit($formEl, $statusEl) {
    var $btn = $formEl.find('.inquiry-form__submit, button[type="submit"]');
    var name = $formEl.find('input[name="name"]').val().trim();
    var phone = $formEl.find('input[type="tel"]').val().trim();
    var comment = $formEl.find('textarea[name="comment"]').val().trim();
    var stone = $formEl.find('input[name="stone"]').val();

    if (!name || !phone) {
      $statusEl.text('Заполните имя и телефон').addClass('inquiry-form__status--error');
      return;
    }

    var digits = phone.replace(/\D/g, '');
    if (digits.length < 10) {
      $statusEl.text('Введите корректный номер телефона').addClass('inquiry-form__status--error');
      return;
    }

    $btn.prop('disabled', true).text('Отправка...');
    $statusEl.text('').removeClass('inquiry-form__status--error inquiry-form__status--ok');

    $.ajax({
      url: WORKER_URL,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ name: name, phone: phone, comment: comment, stone: stone }),
      success: function () {
        $statusEl.text('Заявка отправлена! Мы свяжемся с вами.').addClass('inquiry-form__status--ok');
        $btn.prop('disabled', true).text('Отправлено');
        if ($formEl.is('#inquiry-form')) {
          setTimeout(closeModal, 2000);
        }
        setTimeout(function () {
          $formEl[0].reset();
          $btn.prop('disabled', false).text('Отправить заявку');
          $statusEl.text('').removeClass('inquiry-form__status--ok');
        }, 3000);
      },
      error: function () {
        $statusEl.text('Ошибка отправки. Позвоните нам: +7 (495) 374-83-98').addClass('inquiry-form__status--error');
        $btn.prop('disabled', false).text('Отправить заявку');
      },
    });
  }

  // Modal form submit
  $form.on('submit', function (e) {
    e.preventDefault();
    handleSubmit($form, $status);
  });

  // CTA form on homepage
  $('#cta-form').on('submit', function (e) {
    e.preventDefault();
    handleSubmit($(this), $('#cta-status'));
  });
}
